/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import { Helmet } from "react-helmet"
import { DefaultMeta } from "../../../carlsberg-headless/types/DefaultMeta"
import { SeoMeta } from "../../../carlsberg-headless/types/SeoMeta"

export interface OpenGraphProps {
  defaultMeta?: DefaultMeta
  seoMeta?: SeoMeta
}

const OpenGraph: React.FC<OpenGraphProps> = ({ defaultMeta, seoMeta }) => {
  if (!defaultMeta && !seoMeta) return null

  return (
    <Helmet>
      <meta property="og:type" content="website" />
      {(defaultMeta?.ogDefaultTitle || seoMeta?.openGraphTitle) && (
        <meta
          property="og:title"
          content={seoMeta?.openGraphTitle ?? defaultMeta?.ogDefaultTitle ?? ""}
        />
      )}
      {(defaultMeta?.ogDefaultDescription || seoMeta?.openGraphDescription) && (
        <meta
          property="og:description"
          content={
            seoMeta?.openGraphDescription ??
            defaultMeta?.ogDefaultDescription ??
            ""
          }
        />
      )}

      {seoMeta?.openGraphImage?.fullUrl && (
        <meta
          property="og:image"
          content={`${seoMeta.openGraphImage.fullUrl}?width=1200&height=630`}
        />
      )}

      <meta name="twitter:card" content="summary_large_image" />
      {(defaultMeta?.ogDefaultTitle || seoMeta?.openGraphTitle) && (
        <meta
          name="twitter:title"
          content={seoMeta?.openGraphTitle ?? defaultMeta?.ogDefaultTitle ?? ""}
        />
      )}

      {(defaultMeta?.ogDefaultDescription || seoMeta?.openGraphDescription) && (
        <meta
          name="twitter:description"
          content={
            seoMeta?.openGraphDescription ??
            defaultMeta?.ogDefaultDescription ??
            ""
          }
        />
      )}
      {seoMeta?.openGraphImage?.fullUrl && (
        <meta
          name="twitter:image"
          content={`${seoMeta.openGraphImage.fullUrl}?width=1200&height=630`}
        />
      )}
    </Helmet>
  )
}

export { OpenGraph }
